<template>
    <div class="page_czj flex-col">
        <div class="block_54 flex-col">

            <div class="group_70 flex-col">
                <div class="text-group_231 flex-col justify-between">
                    <span class="text_199">为什么选择我们</span>
                    <span class="text_200">CORE STRENGTH</span>
                </div>
                <div class="group_108 flex-row justify-between">
                    <div class="group_109 flex-col">
                        <div
                                v-for="(item, index) in items"
                                :key="index"
                                class="flex-row"
                                :class="activeIndex === index ? (index === 0 ? 'section_33_hover_first' : 'section_33_hover')
      : 'section_33'"

                                @click="handleSelectIndex(index)"
                                @mouseover="hoverIndexFun(index) "
                                @mouseleave="offhoverIndexFun"
                        >
                            <img class="label_11" :src="item.icon" />
                            <span :class="['text', activeIndex === index ? 'text_201' : 'text_202']">
                {{ item.text }}
              </span>
                        </div>
                    </div>
                    <div class="group_73 flex-col">
                        <img
                                class="image_37"
                                referrerpolicy="no-referrer"
                                :src="mainPic"
                        />
                        <div class="image-text_195 flex-row justify-between">
                            <img
                                    class="thumbnail_9"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/home/chpc_about_industry_02.png"
                            />
                            <transition name="fade" mode="out-in">
                <span class="text-group_147" :key="activeIndex">
                  {{ items[activeIndex].content }}
                </span>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectedIndex:0,
                hoverIndex:-1,
                activeIndex: 0, // 当前激活的条目索引
                mainPic:require('../../../assets/advisory/advisory_core_select01.png'),
                items: [
                    {
                        icon: require('../../../assets/home/chpc_about_industry_03.png'),
                        text: '行业创新实践沉淀',
                        content:'康柏汉森深耕渠道风控领域近二十年，作为国内早期专业服务开拓者，率先将国际核查标准与本土医药行业特性结合，形成覆盖“理念+方法论+工具+执行”的服务模式。通过100余家药械及大健康行业客户服务经验，已构建从基础数据核验到深度业务穿透的阶梯式解决方案库，持续引领行业服务标准升级。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_04.png'),
                        text: '全链路穿透能力',
                        content:'覆盖渠道业务通路全链条，针对企业内部人员、经销商、药店及诊所等环节，通过多源数据交叉验证（如DDI数据、流向数据、仓储数据、追溯信息），有效识别窜货、费用虚高、数据篡改等风险。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_05.png'),
                        text: '本土化动态风控能力',
                        content:'基于行业政策变化及区域商业实践的深度洞察，定期更新核查模型和方法论，提供符合市场环境的定制化风控策略；配合资深经验团队，高灵敏度识别区域差别导致的终端隐患。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_06.png'),
                        text: '智能决策支持',
                        content:'依托自主研发的企业健康管理智慧中心，具备可视化经销商、产品、终端、进销存业务等的健康度评估及风险智能筛选能力，能够精准量化风险等级并提供优化建议，助力企业提升营销资源分配效率与ROI。',
                    }
                ],
            };
        },
        methods: {
            handleSelectIndex(index){
                this.activeIndex = index;
                this.selectedIndex = index;
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.activeIndex = index;
            },
            //定位为最后一个hover的
            offhoverIndexFun(){
                //this.activeIndex = this.selectedIndex ;
                //this.hoverIndex = -1;
            },
        }
    };
</script>
<style scoped lang="css"  >
    .page_czj {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        min-width: 1200px;
        overflow: hidden;
    }

    .block_54 {
        position: relative;
        min-width: 1200px;
        margin-bottom: 1px;
        align-items: center;
    }

    .group_70 {
        background-color: rgba(255, 255, 255, 1);
        min-width: 1200px;
        height: 600px;
        align-items: center; /* 新增 */
        margin-left: 0; /* 移除原134px左边距 */
    }

    .text-group_231 {
        width: 100%;
        height: 96px;
        margin: 50px 0 0 0;
        display: flex;
        align-items: center;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_199 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_200 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;

        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
    }

    .group_108 {
        width: 1105px;
        height: 355px;
        margin: 39px 0 60px 0;
    }

    .group_109 {
        width: 520px;
        height: 355px;
        gap: 28px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .section_33_hover {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 510px;
        height: 69px;
        margin: 0 0 0 1px;
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }
    .section_33_hover_first {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 510px;
        height: 69px;
        margin: 0 0 0 1px; /* 去除上边距 */
        transition: all 0.3s;
        cursor: pointer;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_33 {
        border-radius: 4px;
        width: 510px;
        height: 69px;
        border: 1px solid rgba(232, 232, 232, 1);
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }

    .label_11 {
        width: 22px;
        height: 24px;
        margin: 20px 0 0 25px;
    }

    .text_201 {
        width: 382px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(0, 120, 126, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 19px 64px 0 27px;
    }
    .text_202 {
        width: 360px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 20px 77px 0 26px;
    }

    .group_73 {
        box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 1);
        width: 548px;
        height: 351px;
    }

    .image_37 {
        width: 550px;
        height: 120px;
        margin-left: -1px;
    }

    .image-text_195 {
        width: 501px;
        height: 180px;
        margin: 20px 0 31px 12px;
    }

    .thumbnail_9 {
        width: 12px;
        height: 14px;
        margin-top: 8px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .text-group_147 {
        width: 478px;
        height: 180px;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 30px;
    }

</style>
